export default {
  'device.router.name': 'Device',
  'device.router.nameBreadcrumb': 'Device Management',
  'device.title': 'Managing Devices',
  'device.table.name': 'Device Name',
  'device.table.code': 'Identification Code',
  'device.table.specificAddress': 'Installation Address',
  'device.table.operationStatus': 'Operational Status',
  'device.table.connectionStatus': 'Connection Status',
  'device.table.playingStatus': 'Broadcast Status',
  'device.table.operationStatus.param':
    '{status,select, 1 {Enabled} 2 {Not Enabled} other {Undefined}}',
  'device.table.connectionStatus.param':
    '{status,select, 1 {Connected} 2 {Disconnected} other {Undefined}}',
  'device.table.playingStatus.param':
    '{status,select, 1 {Broadcasting} 2 {Not Broadcasting} 3 {Offline Check} other {Unknown}}',
  'device.delete.title': 'Device Deletion Confirmation',
  'device.delete.content':
    'Are you sure to delete the selected device(s), this action can not be reversed?',
  'device.restart.title': 'Device Restart Confirmation',
  'device.restart.content': 'The selected device(s) will be restarted',
  'device.volume.title': 'Device Volume Control',
  'device.filter.operationStatus': 'Operational Status',
  'device.filter.operationStatus.active': 'Enabled',
  'device.filter.operationStatus.notActive': 'Not Enabled',
  'device.filter.connectionStatus': 'Connection Status',
  'device.filter.connectionStatus.active': 'Connected',
  'device.filter.connectionStatus.notActive': 'Disconnected',
  'device.filter.playingStatus': 'Broadcast Status',
  'device.filter.playingStatus.active': 'Broadcasting',
  'device.filter.playingStatus.notActive': 'Not Broadcasting',
  'device.filter.playingStatus.undefined': 'Offline Check',
  'device.qrCode.title': 'Device Login Code',
  'device.qrCode.text': 'Scan QR code or enter code to log in to the device',
  'device.modal.create': 'Add Device',
  'device.modal.update': 'Update Device',
  'device.modal.create.form.name': 'Device Name',
  'device.modal.create.form.name.validator': 'Invalid device name format',
  'device.modal.create.form.code': 'Device Identification Code',
  'device.modal.create.form.code.validator': 'Invalid identification code format',
  'device.modal.create.form.subscriberNumber': 'SIM Number',
  'device.modal.create.form.managementCode': 'Device Management Code',
  'device.modal.create.form.managementCode.overLength': 'Device code must not exceed 30 characters.',
  'device.modal.create.form.serialNumber': 'SIM Serial Number',
  'device.modal.create.form.supplierId': 'Provider',
  'device.modal.create.form.operationStatus': 'Operational Status',
  'device.modal.create.form.operationStatus.active': 'Enabled',
  'device.modal.create.form.operationStatus.notActive': 'Not Enabled',
  'device.modal.create.form.description': 'Description',
  'device.router.info.name': 'Device Information',
  'device.info.tabs.detail': 'Device Information',
  'device.info.tabs.broadcast': 'Broadcast History',
  'device.info.tabs.activity': 'Device Activity History',
  'device.info.detail.sidebar.title': 'Device Information',
  'device.info.detail.sidebar.name': 'Device Name',
  'device.info.detail.sidebar.code': 'Device Identification Code',
  'device.info.detail.sidebar.managementCode': 'Device Management Code',
  'device.info.detail.sidebar.resolution': 'Resolution',
  'device.info.detail.sidebar.specificAddress': 'Address',
  'device.info.detail.sidebar.subscriberNumber': 'SIM Number',
  'device.info.detail.sidebar.serialNumber': 'SIM Serial Number',
  'device.info.detail.sidebar.supplierId': 'Provider',
  'device.info.detail.sidebar.sdFree': 'Device Capacity',
  'device.info.detail.sidebar.version': 'Version',
  'device.info.detail.sidebar.operationStatus': 'Status',
  'device.info.detail.sidebar.operationStatus.param':
    '{status,select, 1 {Enabled} 2 {Not Enabled} other {Undefined}}',
  'device.info.detail.sidebar.connectionStatus': 'Connection Status',
  'device.info.detail.sidebar.connectionStatus.param':
    '{status,select, 1 {Connected} 2 {Disconnected} other {Undefined}}',
  'device.info.detail.sidebar.playingStatus': 'Broadcast Status',
  'device.info.detail.sidebar.playingStatus.param':
    '{status,select, 1 {Broadcasting} 2 {Not Broadcasting} 3 {Offline Check} other {Unknown}}',
  'device.info.detail.sidebar.description': 'Description',
  'device.info.detail.sidebar.facility': 'Location',
  'device.info.detail.sidebar.location': 'Location',
  'device.info.detail.delete.title': 'Device Deletion Confirmation',
  'device.info.detail.delete.content':
    'Are you sure to delete the selected device(s), this action can not be reversed?',
  'device.info.detail.restart.title': 'Device Restart Confirmation',
  'device.info.detail.restart.content': 'The selected device(s) will be restarted',
  'device.info.detail.card.normal': 'Normal Schedule',
  'device.info.detail.card.prioritize': 'Priority Schedule',
  'device.info.detail.card.bulletinStatus.id':
    '{status, select, 1 {Waiting for Approval} 2 {Refused} 3 {Canceled} 4 {Unprocessed} 5 {Broadcasting} 6 {Paused} 7 {Finished} 8 {Waiting for Broadcast} 9 {Upcoming} other {--}}',
  'device.info.detail.calendar.day': 'Day',
  'device.info.detail.calendar.title': 'Broadcast Schedule',
  'device.info.detail.calendar.viewBy': 'View By',
  'device.info.detail.calendar.titleDate': '1. All Day Schedule',
  'device.info.detail.calendar.myNew': 'My Schedule(s)',
  'device.info.detail.calendar.fatherNew': 'Appointed Schedule(s)',
  'device.info.detail.calendar.cancelNew': 'Cancelled Schedule(s)',
  'device.info.detail.calendar.viewMore': 'View More',
  'device.info.detail.calendar.newOther': 'Other Schedule(s)',
  'device.info.detail.calendar.viewLess': 'View Less',
  'device.info.detail.calendar.hour': 'Hour',
  'device.info.detail.calendar.minutes': 'Minutes',
  'device.info.detail.calendar.titleTime': '2. By Hours Schedule',
  'device.info.detail.calendar.moreTime': 'Time Mode',
  'device.info.playLogs.title': 'Broadcast History',
  'device.info.playLogs.table.newsletter.title': 'Schedule Name',
  'device.info.playLogs.table.duration': 'Duration',
  'device.info.playLogs.table.startTime': 'Start Time',
  'device.info.playLogs.table.endTime': 'End Time',
  'device.info.playLogs.filter.createdAt': 'Start Time',
  'device.info.activityHistory.title': 'Device Activity History',
  'device.info.activityHistory.table.time': 'Time',
  'device.info.activityHistory.table.actionType': 'Action',
  'device.info.activityHistory.table.note': 'Content',
  'device.info.activityHistory.filter.createdAt': 'Time',
  'device.info.activityHistory.table.actionType.downloadSuccessfully': 'Downloaded Successfully',
  'device.info.activityHistory.table.actionType.downloadError': 'Download Failed',
  'device.info.activityHistory.table.actionType.broadcast': 'Broadcast',
  'device.info.activityHistory.table.actionType.paused': 'Paused Broadcast',
  'device.info.activityHistory.table.actionType.requestServer': 'Deleted Broadcast',
  'device.info.activityHistory.table.actionType.expired': 'Deleted Expired Broadcast',
  'device.info.activityHistory.table.actionType.connected': 'Reconnected',
  'device.info.activityHistory.table.actionType.disconnected': 'Disconnected',
  'device.info.activityHistory.table.actionType.reboot': 'Restarted Device',
  'device.info.activityHistory.table.actionType.adjustVolume': 'Adjusted Volume',
  'device.info.activityHistory.table.actionType.newsLetterEnded': 'Broadcast Ended',
  'device.info.activityHistory.table.actionType.newsLetterResume': 'Resumed Broadcast',
  'device.info.activityHistory.table.actionType.changeInfoSource': 'Changed Information Source',
  'device.modalInfoLogin.title': 'Confirmation of login',
  'device.modalCode.title': 'Enter the device code',
  'device.modalCode.text': 'Enter the login code displayed on the device screen',
  'device.modalCode.form.code': 'Equipment code',
  'common.login-qr': 'Log in device',
  'device.quantity.label': 'Number of devices',
  'device.quantity.warning.title': 'You have reached the device limit',
  'device.quantity.warning.content':
    'The number of devices has reached the limit of the current subscription you are using. You can change to another subscription or remove inactive devices.',
  'device.quantity.warning.btn.upgrade': 'Upgrade',
  'device.quantity.warning.message':
    'You do not have permission to access this feature, please contact the organization owner.',
  'device.modalInfoLogin.text': 'If you log in, the connected device will automatically log out.',
  'device.login-device': 'Log in',
  'device.refuse': 'Refuse',
  'device.time': 'Time',
  'device.address': 'Location',
  'device.login-qr': 'Log in device',
  'device.inform.title': 'Notification',
  'device.inform.content':
    'You are approaching the device limit of the upcoming plan. According to the plan, by {date}, the new plan will be limited to {deviceQuantity} device(s). You may consider adjusting the plan for a better fit.',
  'device.inform.okText': 'Subscription Management',
  'device.table.deviceGroup': 'Device Group(s)',
  'device.modal.create.form.deviceGroup': 'Device Group(s)',
  'device.info.detail.sidebar.deviceGroup': 'Device Group(s)',
  'device.filter.deviceGroups': 'Device Group(s)',
  'device.info.activityHistory.filter.actionType': 'Activity',
  'device.info.activityHistory.filter.actionType.downloadSuccessfully': 'Downloaded Successfully',
  'device.info.activityHistory.filter.actionType.downloadError': 'Download Failed',
  'device.info.activityHistory.filter.actionType.broadcast': 'Broadcast',
  'device.info.activityHistory.filter.actionType.paused': 'Paused Broadcast',
  'device.info.activityHistory.filter.actionType.requestServer': 'Deleted Broadcast',
  'device.info.activityHistory.filter.actionType.expired': 'Deleted Expired Broadcast',
  'device.info.activityHistory.filter.actionType.connected': 'Reconnected',
  'device.info.activityHistory.filter.actionType.disconnected': 'Disconnected',
  'device.info.activityHistory.filter.actionType.reboot': 'Restarted Device',
  'device.info.activityHistory.filter.actionType.adjustVolume': 'Adjusted Volume',
  'device.info.activityHistory.filter.actionType.newsLetterEnded': 'Broadcast Ended',
  'device.info.activityHistory.filter.actionType.newsLetterResume': 'Resumed Broadcast',
  'device.info.activityHistory.filter.actionType.changeInfoSource': 'Changed Information Source',
  'device.info.action.login.name': 'Log in device',
  'device.info.detail.sidebar.ipAddress': 'IP Address',
  'device.info.activityHistory.table.actionType.deleteFile': 'Delete Broadcast File',
  'device.info.activityHistory.table.actionType.deleteFileError': 'Failed to Delete Broadcast File',
  'device.info.activityHistory.table.actionType.networkDisconnected': 'Network Disconnected',
  'device.info.activityHistory.filter.actionType.deleteFile': 'Delete Broadcast File',
  'device.info.activityHistory.filter.actionType.deleteFileError':
    'Failed to Delete Broadcast File',
  'device.info.activityHistory.filter.actionType.networkDisconnected': 'Network Disconnected',
  'device.info.activityHistory.table.actionType.deviceInvalidConnectSession':
    'Invalid Connection Time',
  'device.info.activityHistory.filter.actionType.deviceInvalidConnectSession':
    'Invalid Connection Time',
  'device.action.label.screenshot': 'Take device screenshot',
  'device.action.label.screenshot.popup.title': 'Confirm screenshot',
  'device.action.label.screenshot.popup.content':
    'Are you sure you want to take a screenshot of the current device?',
  'device.action.label.screenshot.popup.failed.title': 'Screenshot failed',
  'device.action.label.screenshot.popup.failed.content':
    'Do you want to try taking the screenshot of the device again?',
  'device.action.label.screenshot.popup.failed.cancelText': 'Retry',
  'device.modal.screenshot.title': 'Screenshot',
  'device.modal.screenshot.text':
    'You can view the captured image in <strong>Device activity history</strong>',
  'device.info.action.label.screenshot': 'Take device screenshot',
  'device.info.action.label.screenshot.popup.title': 'Confirm screenshot',
  'device.info.action.label.screenshot.popup.content':
    'Are you sure you want to take a screenshot of the current device?',
  'device.info.action.label.screenshot.popup.failed.title': 'Screenshot failed',
  'device.info.action.label.screenshot.popup.failed.content':
    'Do you want to try taking the screenshot of the device again?',
  'device.info.action.label.screenshot.popup.failed.cancelText': 'Retry',
  'device.info.activityHistory.table.actionType.deviceScreenshot': 'Take Screenshot',
  'device.info.activityHistory.table.actionType.screenshotError': 'Screenshot Failed',
  'device.info.activityHistory.filter.actionType.deviceScreenshot': 'Take Screenshot',
  'device.info.activityHistory.filter.actionType.screenshotError': 'Screenshot Failed',
  'device.info.activityHistory.table.actionType.devicePeriodicScreenshot': 'Screenshot From Device',
  'device.info.activityHistory.filter.actionType.devicePeriodicScreenshot':
    'Screenshot From Device',
  'device.modal.create.form.locationMethod': 'Location Method',
  'device.modal.create.form.locationMethod.value.1': 'Use Device GPS',
  'device.modal.create.form.locationMethod.value.2': 'Enter Coordinates',
  'device.modal.create.form.manualLongitude': 'Longitude',
  'device.modal.create.form.manualLatitude': 'Latitude',
  'device.modal.create.form.resolution': 'Resolution',
  'device.modal.create.form.resolution.width': 'Width',
  'device.modal.create.form.resolution.height': 'Height',
  'device.modal.create.form.resolution.validator': 'Please enter the full device resolution.',
  'device.info.activityHistory.table.actionType.loginOtherDevice': 'Device Login',
  'device.info.activityHistory.filter.actionType.loginOtherDevice': 'Device Login',
  'device.action.label.cleanUpFiles': 'Clean Up Files',
  'device.action.label.cleanUpFiles.popup.title': 'Confirm file cleanup on device',
  'device.action.label.cleanUpFiles.popup.content':
    'The device will remove low-priority or unnecessary files to optimize available storage.',
  'device.info.action.label.cleanUpFiles': 'Clean Up Files',
  'device.info.action.label.cleanUpFiles.popup.title': 'Confirm file cleanup on device',
  'device.info.action.label.cleanUpFiles.popup.content':
    'The device will remove low-priority or unnecessary files to optimize available storage.',
  'device.info.activityHistory.table.actionType.cleanupFile': 'Clean Up Files',
  'device.info.activityHistory.filter.actionType.cleanupFile': 'Clean Up Files',
  'device.info.activityHistory.table.actionType.mediaPlayback': 'Media Playback',
  'device.info.activityHistory.filter.actionType.mediaPlayback': 'Media Playback',
  'device.info.activityHistory.filter.actionType.downloadMediaFailed': 'Media Download Failed',
  'device.info.activityHistory.filter.actionType.downloadMediaSucceed': 'Media Download Succeeded',
  'device.info.activityHistory.filter.actionType.deleteMediaFile': 'Delete Media File',
  'device.info.activityHistory.filter.actionType.deleteMediaFileError': 'Delete Media File Failed',
  'device.info.activityHistory.table.actionType.downloadMediaFailed': 'Media Download Failed',
  'device.info.activityHistory.table.actionType.downloadMediaSucceed': 'Media Download Succeeded',
  'device.info.activityHistory.table.actionType.deleteMediaFile': 'Delete Media File',
  'device.info.activityHistory.table.actionType.deleteMediaFileError': 'Delete Media File Failed',
};
